import './story-downloadable-assets.scss';

import StoryDownloadableAssets from './StoryDownloadableAssets';

export default StoryDownloadableAssets;
